import axios from "axios";
import { Global } from "../../config/global";


export const getOperatorsToAsing = async (idEmpresa) => { //Función para traer los operadores disponibles.
    try {
        let token = localStorage.getItem('token'); // Extraer el token del localStorage.
        let idEmpresa = localStorage.getItem("idEmpresa")
        let url = Global.url + `user/list/${idEmpresa}`;
        let headers = { // Definir el encabezado de la petición.
            Authorization: `Bearer ${token}`
        };
        const response = await axios.get(url, /* {}, */ { headers });
        console.log("los usuarios para asignar", response);
        return response;
    } catch (error) {
        console.log("error al traer los usuarios para asignar: ", error)
    }
};
